import Apple from '../../assets/apple.png'
import Tesla from '../../assets/Tesla.png'
import Microsoft from '../../assets/microsoft.png'
export const CompanyData = [
    {name: 'Apple', logo: Apple},
    {name: 'Microsoft', logo: Microsoft},
    {name: 'Tesla', logo: Tesla},
    {name: 'Apple', logo: Apple},
    {name: 'Apple', logo: Apple},
    {name: 'Apple', logo: Apple},
    {name: 'Apple', logo: Apple},
    {name: 'Apple', logo: Apple},
    {name: 'Apple', logo: Apple},
    {name: 'Apple', logo: Apple},
    {name: 'Apple', logo: Apple},
    {name: 'Apple', logo: Apple},
    {name: 'Apple', logo: Apple},
    {name: 'Apple', logo: Apple},
    {name: 'Apple', logo: Apple},
    {name: 'Apple', logo: Apple},
    {name: 'Apple', logo: Apple},
    {name: 'Apple', logo: Apple},
]